export default "__VITE_ASSET__C0NmD5zJ__"